<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Matbuu Şablonlar</h1>
        <el-button-group v-if="Yetki" class="YeniBtn">
          <el-button type="info" size="small" @click="this.KisiBilgi"> Kişi Bilgi
          </el-button>
          <el-button type="info" size="small" @click="this.YeniBtn"> Şablon Oluştur
          </el-button>
        </el-button-group>
      </div>
      <div class="icerik">
        <el-row :gutter="24">
          <Yukleniyor :data="lo"></Yukleniyor>
          <el-col :span="4" v-for="Matbuu in Liste">
            <div class="matbuu">
              <i class="feather-printer"></i>
              <p>{{Matbuu.Adi}}</p>
              <el-button-group class="mt-2">
                <el-button
                  size="mini"
                  type="primary"
                  icon="feather-edit-2"
                  @click="DuzenleBtn(Matbuu)">
                  Düzenle
                </el-button>
                <el-button
                  v-if="!Matbuu.Tip"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete-solid"
                  @click="SilOnay(Matbuu.id)">
                  Sil
                </el-button>
              </el-button-group>
            </div>
          </el-col>

        </el-row>

      </div>
    </div>
    <el-dialog
      v-if="Yetki"
      :title="Form.Baslik"
      :visible.sync="ModalOlayi"
      center
      width="60%">
      <a @click="ModalOlayi = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-dropdown v-for="d in Degisken" v-if="Form.Tip!=1" @command="DegiskenAdd">
        <el-button size="mini" type="primary">
          {{d.Key}}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-tooltip v-for="a in d.Alt" class="item" effect="dark" :content="a.Aciklama" placement="right">
            <el-dropdown-item :command="a.Value">{{a.Key}}</el-dropdown-item>
          </el-tooltip>
        </el-dropdown-menu>
      </el-dropdown>
      <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-form-item v-if="!Form.Tip" label="Şablon Tanımı" prop="Adi">
          <el-input v-model="Form.Adi"></el-input>
        </el-form-item>
        <VueEditor v-model="Form.Icerik"></VueEditor>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">{{$t('eGenel.0')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="Yetki"
      title="Kişi Bilgi"
      :visible.sync="ModalOlayiKisi"
      center
      width="40%">
      <a @click="ModalOlayiKisi = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form @submit.prevent.native="KisiSubmit" ref="KisiForm">
        <el-form-item label="İstek Listesi" prop="Adi">
          <el-select
            v-model="KisiForm.Bilgi"
            multiple
            filterable
            allow-create
            default-first-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="KisiSubmit()"
                   icon="el-icon-check">{{$t('eGenel.0')}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


  import Yukleniyor from "../../components/Doc/Yukleniyor";
  import {VueEditor} from "vue2-editor"

  export default {
    components: {Yukleniyor, VueEditor},
    data() {
      return {
        customToolbar: [
          ["bold", "italic", "underline"],
          [{list: "ordered"}, {list: "bullet"}],
          ["image", "code-block"]
        ],
        lo: false,
        Yetki: false,
        ModalOlayi: false,
        ModalOlayiKisi: false,
        Baslik: null,
        Liste: [],
        FormHata: {
          Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Icerik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
        },
        KisiForm: {
          Bilgi: []
        },
        KisiBilgiler: [],
        Form: {
          Adi: null,
          Icerik: null,
          Tur: null
        },
        Degisken: [
          {
            Key: "İhtar Metni",
            Alt: [
              {
                Key: "Ad Soyad",
                Aciklama: "[AdSoyad] - Borçlu Ad ve Soyad",
                Value: "[AdSoyad]"
              },
              {
                Key: "T.C. Kimlik No",
                Aciklama: "[TcNo] - Borçlu TC Kimlik numarası",
                Value: "[TcNo]"
              },
              {
                Key: "Telefon",
                Aciklama: "[Telefon] - Borçlu Telefon numarası",
                Value: "[Telefon]"
              },
              {
                Key: "Mesken No",
                Aciklama: "[MeskenNo] - Borçlu mesken numarası",
                Value: "[MeskenNo]"
              },
              {
                Key: "Tarih",
                Aciklama: "[Tarih] - Yazdırma tarihi",
                Value: "[Tarih]"
              },
              {
                Key: "Toplam",
                Aciklama: "[Toplam] - Seçilen borçların ödenecek toplamı ",
                Value: "[Toplam]"
              },
              {
                Key: "Liste",
                Aciklama: "[Liste] - Seçilen borçların detaylı listesi ",
                Value: "[Liste]"
              },

            ]

          }]
      }
    },
    methods: {
      DegiskenAdd(command) {

        this.Form.Icerik = this.Form.Icerik + ' ' + command
      },
      KisiSubmit() {
        this.lo = true;
        this.$store.dispatch("Post", {...this.KisiForm, path: 'spesiyal/kisibilgi'})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.ModalOlayiKisi = false
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            // EKLE
            this.$store.dispatch("Post", {...this.Form, path: 'spesiyal/matbuu'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                  this.SayfaYukle()
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }

        });
      },
      KisiBilgi() {
        this.ModalOlayiKisi = true
      },
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'spesiyal/matbuu/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.ModalOlayi = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      DuzenleBtn(Veri) {

        this.Form.Adi = Veri.Adi;
        this.Form.Icerik = Veri.Icerik;
        this.Form.Tip = Veri.Tip;
        this.Form.id = Veri.id;
        this.ModalOlayi = true;
        this.Form.Baslik = Veri.Adi;
        this.Form.Sil = true;

      },
      YeniBtn() {
        this.ModalOlayi = true;
        this.Form.Baslik = 'Yeni Şablon';
        this.Form.Adi = null;
        this.Form.Icerik = null;
        this.Form.id = 0;
        this.Form.Tur = 3;

      },
      SayfaYukle() {
        this.ModalOlayi = true;
        this.Form.Baslik = 'Yeni Şablon';
        this.Form.Adi = null;
        this.Form.Icerik = null;
        this.ModalOlayi = false;
        this.Form.id = 0;

        this.$store.dispatch("Get", {path: 'spesiyal/matbuu/3'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

        this.$store.dispatch("Get", {path: 'spesiyal/kisibilgi'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.KisiForm.Bilgi = response.Bilgi
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.spesiyal == 2 ? true : false;
    }

  }
</script>
<style>
  #quill-container {
    height: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Ekstra/matbuu.vue